import { FRAuth, StepType, UserManager } from "@forgerock/javascript-sdk";
import warningGeneral from "../../assets/warningGeneral.png";
import { startJourney } from "../../utilities/helper";
import { useAuth } from "../../Contexts/AuthContext";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import success from "../../assets/success.png";
import Button from "../../Components/Button";

function Verify() {
  const navigate = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState("");
  const urlParams = new URLSearchParams(window.location.search);
  const { isAuthenticated, setUser } = useAuth();
  const token = urlParams.get("token");

  useEffect(() => {
    if (token) {
      if (isAuthenticated) {
        verifyEmail();
      }
    } else {
      navigate("/home", { replace: true });
    }
  }, [token]);

  const verifyEmail = async () => {
    startJourney(process.env.REACT_APP_JOURNEY_VERIFY_EMAIL);
    try {
      const initialStep = await FRAuth.start({
        query: {
          EmailVerifyLink: token,
          ForceAuth: true,
        },
      });
      switch (initialStep.type) {
        case StepType.LoginSuccess:
          {
            const fr_user = await UserManager.getCurrentUser();
            setUser(fr_user);
            setVerificationStatus("success");
          }
          break;
        case StepType.LoginFailure:
          {
            const detail = initialStep.getDetail();
            if (detail?.failureUrl === "ERR-032") {
              setVerificationStatus("failed");
            } else if (detail?.failureUrl === "ERR-033") {
              setVerificationStatus("expired");
            }
          }
          break;
      }
    } catch (err) {
      setVerificationStatus("failed");
      console.log(err);
    }
  };

  const handleBack = () => {
    navigate("/my-account", { replace: true });
  };

  const values = {
    success: {
      icon: success,
      title: "Verify Success!",
      desc: "You've successfully verified your email address.",
    },
    failed: {
      icon: warningGeneral,
      title: "Verify Failed!",
      desc: "Failed to verify your email address.",
    },
    expired: {
      icon: warningGeneral,
      title: "Verification Link Expired!",
      desc: "The verification link was expired.",
    },
  };

  let content = null;
  if (values[verificationStatus]) {
    content = (
      <div className="flex flex-col items-center justify-center mx-auto sm:my-24 w-full max-w-[400px] p-4 bg-white rounded-xl">
        <img
          src={values[verificationStatus]?.icon}
          className="w-[75px] mb-4"
          alt="icon"
        />
        <p className="text-[#1F2328] text-xl text-center font-bold mb-4">
          {values[verificationStatus]?.title || ""}
        </p>
        <p className="text-[#60656D] text-center mb-4">
          {values[verificationStatus]?.desc || ""}
        </p>
        <Button
          className="h-12 w-full rounded-xl text-white"
          onClick={handleBack}
        >
          Ok
        </Button>
      </div>
    );
  }

  return (
    <div className="w-full h-full min-h-screen sm:bg-[#E7EEFA] overflow-auto flex flex-col justify-center sm:justify-start">
      {content}
    </div>
  );
}

export default Verify;
